var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhiteIconMedicine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 90,
    viewBox: "0 0 107 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 85,
    height: 68,
    rx: 10,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.4727 43.061C54.7738 43.061 53.9546 43.0733 53.3874 43.0917C53.2599 43.0956 53.1389 43.1247 53.0294 43.1702L54.5684 41.2721C56.6293 38.728 56.0878 35.0934 53.3613 33.1702C52.2757 32.4046 50.9839 32 49.6262 32C47.6628 32 45.859 32.837 44.6767 34.2962L33.2553 48.386C32.2569 49.6184 31.8322 51.1398 32.0602 52.6703C32.2873 54.2004 33.1411 55.5572 34.4624 56.4883C35.5485 57.254 36.8398 57.6585 38.1971 57.6585C40.1609 57.6585 41.9639 56.8215 43.1466 55.3619L43.2749 55.2033C43.2642 55.5823 43.5072 55.943 43.911 56.0785C46.2324 56.8614 50.4898 57.698 55.4723 57.698C59.1736 57.698 62.6636 57.346 65.302 56.7087C68.4199 55.9554 70 54.88 70 53.5133V47.2468C70 43.9358 60.4975 43.0614 55.4727 43.061ZM68.0597 47.2417C67.9245 47.8973 63.8511 49.6212 55.4761 49.6212H55.474C53.9717 49.6212 52.5995 49.5598 51.2367 49.4302L61.6999 45.2412C65.8855 45.7844 67.9639 46.7837 68.0597 47.2417ZM53.4563 44.9008C54.0021 44.8829 54.7947 44.8713 55.4736 44.8713C57.0511 44.8713 58.4759 44.9327 59.7515 45.0359L49.3409 49.2043C49.1244 49.1736 48.9084 49.1429 48.6898 49.1086C48.5093 49.0795 48.3335 49.103 48.1731 49.1628L52.4635 43.8685C52.4558 43.9211 52.4498 43.9737 52.4519 44.0279C52.4703 44.5277 52.9331 44.9203 53.4563 44.9008ZM46.2239 35.3875C47.0362 34.3851 48.2758 33.8103 49.6253 33.8103C50.5583 33.8103 51.445 34.0886 52.191 34.6143C54.0637 35.9352 54.4363 38.4327 53.02 40.18L47.6025 46.8646L40.8068 42.0721L46.2239 35.3875ZM41.599 54.271C40.7871 55.273 39.5471 55.8482 38.1975 55.8482C37.2655 55.8482 36.3792 55.57 35.6327 55.0438C34.725 54.4037 34.1399 53.4726 33.9829 52.4216C33.8263 51.3705 34.1185 50.3251 34.8042 49.4781L40.2217 42.7943L47.0173 47.5872L41.599 54.271ZM55.4727 55.8892C50.7362 55.8892 46.6396 55.0745 44.5715 54.3774C44.3644 54.3069 44.1488 54.3104 43.9534 54.367L47.567 49.9089C47.5152 50.3797 47.8592 50.8133 48.3678 50.8934C50.7379 51.2653 52.9301 51.4315 55.4727 51.4315H55.4753C59.1745 51.4315 62.6658 51.08 65.3029 50.4418C66.421 50.1712 67.3381 49.8587 68.0597 49.5068V53.5093C67.9216 54.1662 63.8472 55.8892 55.4727 55.8892Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 0,
    y: 0,
    width: 107,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteIconMedicine);
export default __webpack_public_path__ + "static/media/WhiteIcon_Medicine.daec6386cb3d655ade514e5dbf628d27.svg";
export { ForwardRef as ReactComponent };